import { FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'

interface HeaderCellProps {
  columnType: string
  hasInvertedColors: boolean
  children?: ReactNode
}

type StyledHeaderCellProps = Pick<
  HeaderCellProps,
  'columnType' | 'hasInvertedColors'
>

const StyledHeaderCell = styled.div<StyledHeaderCellProps>`
  ${({
    theme: {
      colors: { textDefault, staticNeutral100 },
      spacing: { spacing12 },
      typography: {
        catchword: {
          small1: { bundledCSS: small1CatchwordCSS },
        },
      },
    },
    columnType,
    hasInvertedColors,
  }) => {
    return css`
      ${small1CatchwordCSS};
      color: ${hasInvertedColors ? staticNeutral100 : textDefault};
      text-transform: uppercase;
      display: grid;
      align-items: center;
      min-height: 48px;
      text-align: ${columnType === 'team' ? 'left' : 'right'};
      padding-right: ${columnType === 'points' ? spacing12 : 0};
    `
  }}
`

const HeaderCell: FunctionComponent<HeaderCellProps> = ({
  columnType,
  hasInvertedColors,
  children,
}) => {
  return (
    <StyledHeaderCell
      columnType={columnType}
      hasInvertedColors={hasInvertedColors}>
      {children}
    </StyledHeaderCell>
  )
}

export default HeaderCell
